import React from "react";
import Form from '../custom/Form'
import { Text, Box, Input, Button } from "@chakra-ui/react";
import { UseFormReturnType } from "@mantine/form";
import { AdminData } from "../../pages/admin/new_admin";
import { VStack } from "@chakra-ui/react";
import { PasswordInput } from '../forms/ChangePasswordForm'

interface Props {
  form: UseFormReturnType<{
    firstName: string,
    lastName: string,
    email: string,
    password: string,
    role: string
  }>,
  handleNewAdmin: (adminData: AdminData) => void,
  mutation: any
}

const NewAdminForm: React.FC<Props> = ({
  form, 
  mutation,
  handleNewAdmin 
}) => {
  return (
    <Form
      onSubmit={form.onSubmit((values) => handleNewAdmin(values))}
    >
      <Text 
        fontWeight='semibold' fontSize='lg' 
        mt='10' color='gray.500'>
        Add New Admin
      </Text>

      <VStack
        pt='8' pb='10' px='7' boxShadow='md' borderRadius='8' maxW='40rem' w='100%' mt='5' spacing='5'
      >
        <Box w='100%'>
          <Text fontWeight='semibold' color='gray.500'>
            First Name
          </Text>

          <Box mt='2'>
            <Input 
              {...form.getInputProps('firstName')}
              disabled={mutation.isLoading}
              size='lg' mt={1} placeholder="Jane" 
              border={form.errors.firstName ? '2px' : '1px'}
              borderColor={form.errors.firstName ? 'red.500' : 'gray.500'} color='gray.500'
              focusBorderColor={form.errors.firstName ? 'red.500' : 'gray.500'}
              _hover={{ outlineColor: 'transparent' }} 
            />

            {form.errors.firstName &&
              <Text fontWeight='semibold' mt={1} color='red.500'>
                {form.errors.firstName}
              </Text>
            }
          </Box>
        </Box>

        <Box w='100%'>
          <Text fontWeight='semibold' color='gray.500'>
            Last Name
          </Text>

          <Box mt='2'>
            <Input
              {...form.getInputProps('lastName')}
              disabled={mutation.isLoading}
              size='lg' mt={1} placeholder="Doe"
              border={form.errors.lastName ? '2px' : '1px'}
              borderColor={form.errors.lastName ? 'red.500' : 'gray.500'} color='gray.500'
              focusBorderColor={form.errors.lastName ? 'red.500' : 'gray.500'}
              _hover={{ outlineColor: 'transparent' }}
            />

            {form.errors.lastName &&
              <Text fontWeight='semibold' mt={1} color='red.500'>
                {form.errors.lastName}
              </Text>
            }
          </Box>
        </Box>

        <Box w='100%'>
          <Text fontWeight='semibold' color='gray.500'>
            Email
          </Text>

          <Box mt='2'>
            <Input
              {...form.getInputProps('email')}
              disabled={mutation.isLoading}
              size='lg' mt={1} placeholder="example@example.com"
              border={form.errors.email ? '2px' : '1px'}
              borderColor={form.errors.email ? 'red.500' : 'gray.500'} color='gray.500'
              focusBorderColor={form.errors.email ? 'red.500' : 'gray.500'}
              _hover={{ outlineColor: 'transparent' }}
            />

            {form.errors.email &&
              <Text fontWeight='semibold' mt={1} color='red.500'>
                {form.errors.email}
              </Text>
            }
          </Box>
        </Box>

        <Box w='100%'>
          <Text fontWeight='semibold' color='gray.500'>
            Password
          </Text>

          <Box mt='2'>
            <PasswordInput
              props={{ ...form.getInputProps('password') }}
              disabled={mutation.isLoading}
              border={form.errors.password ? '2px' : '1px'}
              borderColor={form.errors.password ? 'red.500' : 'gray.500'}
              focusBorderColor={form.errors.password ? 'red.500' : 'gray.500'}
            />

            {form.errors.password &&
              <Text fontWeight='semibold' mt={1} color='red.500'>
                {form.errors.password}
              </Text>
            }
          </Box>
        </Box>

        {form.isTouched() &&
          <Box w='100%' mt={5}>
            <Button
              isLoading={mutation.isLoading}
              type="submit"
              bg='#37A75B' size="lg"
              w='100%' color='white'
              _hover={{ backgroundColor: mutation.isLoading ? '#37A75B' : '#046425' }}
            >
              Add Admin
            </Button>
          </Box>
        }
      </VStack>
    </Form>
  )
}

export default NewAdminForm